module.exports = __webpack_public_path__ + "static/media/brown.c15a03d4.png";